<forge-card class="chart" no-padding [fxShow]="!hidden">
    <forge-toolbar attr.slot="header">
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">Percent of Open Enrollment Completed</h2>
        </div>
    </forge-toolbar>

    <div class="metadata-padding">
        <ng-container *ngIf="hasDataCompleteCard">
            <div *ngFor="let data of data">
                <open-enrollment-complete-chart [data]="data" (drillIn)="drillIn()" [index]="$index">
                </open-enrollment-complete-chart>
            </div>
        </ng-container>
    
        <busy-indicator *ngIf="chartLoading" chart="true"></busy-indicator>
    
        <div [fxShow]="!chartLoading && !ChartHasData">Not enough data to display graph</div>
    </div>
</forge-card>